module.exports = __webpack_public_path__ + "img/流体力学3_4.c886191c.jpg";